import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const getRandomData = () => new Array(7).fill(0).map(() => Math.floor(Math.random() * 100));

const getState = (dataIndicador) => {
  let resumeIndicator = {
    labels: getFilterNamesData(),
    datasets: [
      {
        label: dataIndicador[0].mes,
        backgroundColor: '#55e5bb', 
        borderColor: '#55e5bb',
        borderWidth: 1,
        hoverBackgroundColor: '#55e5bb',
        hoverBorderColor: '#55e5bb',
        data: getDataSatisfactionPercent(
            dataIndicador[0].porcentajeMuyBuena,
            dataIndicador[0].porcentajeBuena,
            dataIndicador[0].porcentajeRegular,
            dataIndicador[0].porcentajeMala,
            dataIndicador[0].porcentajeMuyMala
        ),
      },
      {
        label: dataIndicador[1].mes,
        backgroundColor: '#3EA3FC', 
        borderColor: '#3EA3FC',
        borderWidth: 1,
        hoverBackgroundColor: '#3EA3FC',
        hoverBorderColor: '#3EA3FC',
        data: getDataSatisfactionPercent(
            dataIndicador[1].porcentajeMuyBuena,
            dataIndicador[1].porcentajeBuena,
            dataIndicador[1].porcentajeRegular,
            dataIndicador[1].porcentajeMala,
            dataIndicador[1].porcentajeMuyMala
        ),
      },
      {
        label: dataIndicador[2].mes,
        backgroundColor: '#111B21', 
        borderColor: '#111B21',
        borderWidth: 1,
        hoverBackgroundColor: '#111B21',
        hoverBorderColor: '#111B21',
        data: getDataSatisfactionPercent(
            dataIndicador[2].porcentajeMuyBuena,
            dataIndicador[2].porcentajeBuena,
            dataIndicador[2].porcentajeRegular,
            dataIndicador[2].porcentajeMala,
            dataIndicador[2].porcentajeMuyMala
        ),
      }
    ],
  }
  return resumeIndicator;
};

const options = {
  legend: {
    position: 'bottom',
  },
  indexAxis: 'y',
  scales: {
    x: {
      ticks: {
        maxRotation: 0,
        minRotation: 0
      }
    },
    y: {
      ticks: {
        maxRotation: 0,
        minRotation: 0
      }
    }
  }
};

const getFilterNamesData = () => {
  return ["MUY BUENO","BUENO","REGULAR","MALO","MUY MALO"];
}

const getDataSatisfactionPercent = (porcentajeMuyBuena,porcentajeBuena,porcentajeRegular,porcentajeMala,porcentajeMuyMala) => {
  
    let data = [
        parseInt(porcentajeMuyBuena),
        parseInt(porcentajeBuena),
        parseInt(porcentajeRegular),
        parseInt(porcentajeMala),
        parseInt(porcentajeMuyMala)
    ];
    
  return data;
}

const AnimatedBars = ({ dataIndicator }) => {

  const [data, setData] = useState(null);

  useEffect(() => {
    getDataIndicator(dataIndicator);
  }, []);

  const getDataIndicator = async (dataIndicator) => {
    let dataInd = await getState(dataIndicator);
    setData(dataInd);
  }

  return (
    <Col>
      <Card>
        <CardBody>
          <div className="card__title">

          </div>
          {data != null ? <Bar height={70} data={data} options={options} /> : null}
        </CardBody>
      </Card>
    </Col>
  );
};

export default AnimatedBars;
